import React, { Component, createRef } from 'react'
import './AppBar.css'
import { Link, matchPath } from 'react-router-dom'
import { withRouter } from '../../withRouter.jsx'
import { CSSTransition } from 'react-transition-group'
import AuthUserContext from '../../AuthUserContext.jsx'
import GroupsContext from '../../GroupsContext.jsx'
import Logotipo from '../commons/Logotipo.jsx'
import { Action } from '../commons/Actions.jsx'
import isotipo from '../../images/isotipo.png'
import { MenuGroup } from '../modules/Menus.jsx'

const getParams = (pathname) => {
  const matchGroup = matchPath('/g/:id', pathname)
  return (matchGroup && matchGroup.params) || {}
}

class AppBar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      appBarInner: false,
      appBarGroup: false,
      appBarTitle: '',
      groupId: null
    }
    this.appBarInnerRef = createRef()
    this.appBarGroupRef = createRef()
  }
  static getDerivedStateFromProps (props, state) {
    if (props.location.pathname.substring(0, 3) === '/g/') {
      const params = getParams(props.location.pathname)
      return {
        appBarGroup: true,
        appBarInner: false,
        appBarTitle: '',
        groupId: params.id
      }
    } else if (props.location.pathname === '/account') {
      return {
        appBarInner: true,
        appBarGroup: false,
        appBarTitle: 'Configuración de cuenta'
      }
    } else if (props.location.pathname === '/faq') {
      return {
        appBarInner: true,
        appBarGroup: false,
        appBarTitle: 'Preguntas frecuentes'
      }
    } else if (props.location.pathname === '/rules') {
      return {
        appBarInner: true,
        appBarGroup: false,
        appBarTitle: 'Reglas del juego'
      }
    } else if (props.location.pathname === '/about') {
      return {
        appBarInner: true,
        appBarGroup: false,
        appBarTitle: 'Acerca de'
      }
    } else if (props.location.pathname === '/contact') {
      return {
        appBarInner: true,
        appBarGroup: false,
        appBarTitle: 'Contáctanos'
      }
    } else {
      return {
        appBarInner: false,
        appBarGroup: false
      }
    }
  }
  render () {
    return (
      <div className='app_bar'>
        <div className={this.state.appBarInner || this.state.appBarGroup ? 'app_bar__container app_bar__main app_bar__main--hidden' : 'app_bar__container app_bar__main'}>
          <div className='app_bar__logo'>
            <Link to='/'>
              <img src={isotipo} alt='Stadium' />
              <Logotipo />
            </Link>
          </div>
          <div className='app_bar__actions'>
            <Action color icon='group_add' onClick={() => this.props.handleModal('createGroup')} />
            <Action color icon='star' onClick={() => this.props.handleModal('enterGroup')} />
            <Action light icon='menu' onClick={() => this.props.history.push('/settings')} />
          </div>
          <AuthUserContext.Consumer>
            {(authUser) => (
              <div className='app_bar__account'>
                <div className='app_bar__account__name'>{authUser.user.name.substring(0, 14)}</div>
                <div className='app_bar__account__photo'><img src={authUser.user.photo} alt={authUser.user.name} /></div>
              </div>
            )}
          </AuthUserContext.Consumer>
        </div>
        <CSSTransition
          in={this.state.appBarInner}
          nodeRef={this.appBarInnerRef}
          classNames={'app_bar__inner'}
          timeout={400}
          mountOnEnter
          unmountOnExit>
          <div ref={this.appBarInnerRef}>
            <AppBarInner title={this.state.appBarTitle} onClick={() => this.props.history.push('/settings')} />
          </div>
        </CSSTransition>
        <CSSTransition
          in={this.state.appBarGroup}
          nodeRef={this.appBarGroupRef}
          classNames={'app_bar__group'}
          timeout={400}
          mountOnEnter
          unmountOnExit>
          <div ref={this.appBarGroupRef}>
            <AppBarGroup id={this.state.groupId} onClick={() => this.props.history.push('/')} handleModal={this.props.handleModal} />
          </div>
        </CSSTransition>
      </div>
    )
  }
}

const AppBarInner = (props) => (
  <div className='app_bar__container app_bar__inner'>
    <div className='app_bar__actions'>
      <Action color icon='arrow_back' onClick={props.onClick} />
    </div>
    <div className='app_bar__title'>{props.title}</div>
  </div>
)

class AppBarGroup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menu: null
    }
    this.menuRef = createRef()
  }
  render () {
    return (
      <GroupsContext.Consumer>
        {(groups) => {
          const data = groups.find((group) => group.id === this.props.id)
          let cover, title, admin, mode
          if (data) {
            cover = data.cover
            title = data.titulo
            admin = data.admin
            mode = data.mode
          }
          return (
            <div className='app_bar__container app_bar__group'>
              <div className='app_bar__actions'>
                <Action color icon='arrow_back' onClick={this.props.onClick} />
              </div>
              <div className='app_bar__info'>
                <div className='app_bar__info__cover'>{cover && <img alt='Cover' src={cover} />}</div>
                <div className='app_bar__info__col'>
                  <div className='app_bar__info__title'>{title}</div>
                  <div className='app_bar__info__mode'>{mode}</div>
                </div>
                <div className='app_bar__actions'>
                  <Action color icon='more_horiz' onClick={() => this.setState({ menu: true })} />
                </div>
              </div>
              <CSSTransition
                in={this.state.menu}
                nodeRef={this.menuRef}
                classNames={'menu'}
                timeout={200}
                mountOnEnter
                unmountOnExit>
                <div ref={this.menuRef}>
                  <MenuGroup
                    id={this.props.id}
                    title={title}
                    cover={cover}
                    admin={admin}
                    closeMenu={() => this.setState({ menu: null })}
                    handleModal={this.props.handleModal}
                  />
                </div>
              </CSSTransition>
            </div>
          )
        }}
      </GroupsContext.Consumer>
    )
  }
}

export default withRouter(AppBar)
